import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Modal, TextInput, Button } from 'advenio-components'
import { Form } from 'formsy-react'
import { isValidAmount } from '../Validations'
import { formatPrice } from '../../../utils/Utils'

const InputsRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`
const InputContainer = styled.div`
  width: 500px;
`
const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0;
`

class AddDiscountModal extends Component {
  state = {
    isInvalid: true,
  }

  onChange = ({ amount: discount }) => {
    this.setState({
      isInvalid: discount === '' || parseFloat(discount) > this.getTotal(),
    })
  }

  getTotal = (type) => {
    const {
      currency,
      is_retention,
      total: originalTotal,
      totals_before_retention,
    } = this.props
    const shouldFormat = type === 'formatted'
    let total = originalTotal

    if (shouldFormat) {
      total = formatPrice(originalTotal, currency)
    }

    if (is_retention) {
      const totalType = shouldFormat ? 'total_formatted' : 'total'

      total = totals_before_retention[totalType]
    }

    return total
  }

  handleSubmit = data => this.props.sendDiscount(this.props.chargeId, { ...data })

  validateDiscount = ({ amount: discount }) => {
    const isValid = isValidAmount(parseFloat(discount), this.getTotal())

    return !isValid && this.validationText()
  }

  validationText = () => `El monto del descuento debe ser menor o igual a ${this.getTotal('formatted')}`

  render() {
    const { currency, discount, editMode, open, onClose, sending } = this.props

    return (
      <Modal
        isOpened={open}
        onClose={onClose}
        headerTitle={editMode ? 'Ajustar Descuento' : 'Agregar Descuento'}
        statePath="balance"
        actionType="discount"
        typePrefix="BALANCE"
      >
        <Form onSubmit={this.handleSubmit} onChange={this.onChange}>
          <InputsRow>
            <InputContainer>
              <TextInput
                name="description"
                label="Descripción"
                value={discount && discount.description}
              />
            </InputContainer>
            <InputContainer>
              <TextInput
                name="amount"
                label="Monto"
                value={discount && discount.discount_amount}
                validations={{
                  customValidation: this.validateDiscount,
                }}
                help={this.validationText()}
                prefix={currency && currency.symbol}
                suffix={currency && currency.code}
                type="number"
              />
            </InputContainer>
          </InputsRow>
          <ButtonsRow>
            <Button
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              primary
              type="submit"
              loading={sending}
              disabled={this.state.isInvalid}
            >
              Agregar
            </Button>
          </ButtonsRow>
        </Form>
      </Modal>
    )
  }
}

AddDiscountModal.propTypes = {
  /** The ID of the parent charge */
  chargeId: PropTypes.number,
  /** The currency being used. Includes the currency code (e.g. MXN) and symbol (e.g. $) */
  currency: PropTypes.object,
  /** The existing discount, if available */
  discount: PropTypes.object,
  /** Flag marking if the discount is being edited instead of created */
  editMode: PropTypes.bool,
  /** Flag marking if the charge is a retention charge */
  is_retention: PropTypes.bool.isRequired,
  /** Callback function when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Flag marking if the modal should be open */
  open: PropTypes.bool.isRequired,
  /** The charge total */
  total: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  /** An array of totals for the parent charge without retention applied */
  totals_before_retention: PropTypes.object,
  /** Flag marking if the discount is in the process of being sent to the API */
  sending: PropTypes.bool.isRequired,
  /** Callback function to submit the discount to the API */
  sendDiscount: PropTypes.func.isRequired,
}

AddDiscountModal.defaultProps = {
  chargeId: null,
  currency: {},
  discount: {},
  editMode: false,
  total: null,
  totals_before_retention: {},
}

export default AddDiscountModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/AddDiscountModal.jsx